const LANDING_PRODUCTS_SCROLL_KEY = "landing-products-scroll-restore";

let restoreInProgress = false;

export function isLandingScrollRestoreInProgress() {
  return restoreInProgress;
}

export function saveLandingProductsScrollPosition() {
  try {
    sessionStorage.setItem(
      LANDING_PRODUCTS_SCROLL_KEY,
      String(Math.round(window.pageYOffset)),
    );
  } catch {
    // Ignore private-mode / quota errors.
  }
}

export function peekLandingProductsScrollPosition() {
  try {
    const raw = sessionStorage.getItem(LANDING_PRODUCTS_SCROLL_KEY);
    if (raw == null) return null;

    const y = Number(raw);
    return Number.isFinite(y) ? y : null;
  } catch {
    return null;
  }
}

export function clearLandingProductsScrollPosition() {
  try {
    sessionStorage.removeItem(LANDING_PRODUCTS_SCROLL_KEY);
  } catch {
    // Ignore storage errors.
  }
}

export function consumeLandingProductsScrollPosition() {
  const y = peekLandingProductsScrollPosition();
  if (y == null) return null;

  clearLandingProductsScrollPosition();
  restoreInProgress = true;
  return y;
}

export function finishLandingScrollRestore() {
  restoreInProgress = false;
}

export function restoreLandingProductsScrollPosition(y) {
  if (!Number.isFinite(y)) {
    finishLandingScrollRestore();
    return () => {};
  }

  const top = Math.max(0, y);
  let cancelled = false;

  const scroll = () => {
    window.scrollTo({ top, left: 0, behavior: "auto" });
  };

  scroll();

  const timeoutId = window.setTimeout(() => {
    if (!cancelled) scroll();
  }, 250);

  const finishId = window.setTimeout(() => {
    if (!cancelled) finishLandingScrollRestore();
  }, 400);

  return () => {
    cancelled = true;
    window.clearTimeout(timeoutId);
    window.clearTimeout(finishId);
    finishLandingScrollRestore();
  };
}
